import {MobileFormState, MobileNumberForm} from 'src/types/onboarding';
import {FormikContextType} from 'formik';
import UserService from 'src/services/UserService';

export default async function onControlledSubmit(
  form: FormikContextType<MobileNumberForm>,
  actions,
  skipStep: () => void
): Promise<void> {
  const mobile = form.values.mobile || '';
  const shouldSkip =
    (mobile || '').length === 0 ||
    (form.initialValues.mobile === form.values.mobile && form.values.mobileVerified);

  if (shouldSkip) {
    skipStep();
    return;
  }

  const entryState = form.values.mobileFormState;

  switch (entryState) {
    case MobileFormState.INITIAL:
      await UserService.sendPhoneVerification(mobile);
      form.setFieldValue('mobileFormState', MobileFormState.CODE_SENT);
      break;
    case MobileFormState.CODE_SENT:
      const result = await UserService.checkPhoneVerificationCode(
        mobile,
        form.values.verificationCode
      );

      if (result.valid) {
        return form.submitForm();
      } else {
        form.setFieldError('verificationCode', result.error);
      }
      break;
  }
}
